import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import { InputRules } from "@/rules";
import { EarlytimeFlowDat } from "@/models/transaction/EarlytimeFlowDat";
import {
  PulldownResponse,
  codeKbnFilter
} from "@/models/response/PulldownResponse";
import { CodeKbnList } from "@/models/codeMaster/Code";
import { $get, $post } from "@/plugins/api/api";
import { Paths } from "@/plugins/api/paths";
import { $alert } from "@/plugins/alert/alert";
import TimePicker2 from "@/components/TimePicker2.vue";

interface VForm extends Vue {
  reset(): void;
  resetValidation(): void;
  validate(): boolean;
}

type Props = {
  item: EarlytimeFlowDat;
  disabled: boolean;
};
type Emits = {
  (e: "close"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'EarlytimeDialog',
  props: {
    item: null,
    disabled: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "close"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: EarlytimeFlowDat;
  disabled: boolean;
};




const vform = ref<VForm>();

const dat = ref(Object.assign({}, props.item));

const reasonList = ref<string[]>([]);

const isOpen = ref(false);

const getCodeMaster = async () => {
  const code = await $get<PulldownResponse[]>(Paths.codeMasterPulldown);
  if (code) {
    reasonList.value = codeKbnFilter(code, CodeKbnList.OVRSN).map(e => e.name);
  }
};

const initialize = async () => {
  await getCodeMaster();
  dat.value = Object.assign({}, props.item);
};

watch(isOpen, async () => {
  if (isOpen.value) {
    await initialize();
  }
});
const isLoading = ref(false);

const onClose = () => {
  isOpen.value = false;
  emits("close");
};

const createRequest = () => {
  return dat.value;
};

const onSubmit = async () => {
  if (!vform.value?.validate()) {
    $alert("warning", "入力に誤りがあります。\n入力内容を確認してください。");
    return;
  }
  isLoading.value = true;

  const result = await $post(Paths.approval.earlytime.update, createRequest());
  if (result) {
    $alert("success", "変更に成功しました。");
    onClose();
  } else {
    $alert("error", "変更に失敗しました。");
  }
  isLoading.value = false;
};

return { __sfc: true,props, emits, vform, dat, reasonList, isOpen, getCodeMaster, initialize, isLoading, onClose, createRequest, onSubmit, InputRules, TimePicker2 }
}

})